"use strict";import r from"../src/spectrum-two/theme-light.css.js";import{Theme as t}from"../src/Theme.js";import"../src/spectrum-two/core.js";t.registerThemeFragment("light-spectrum-two","color",r);
//# sourceMappingURL=theme-light.js.map
